import React from 'react';
import { MessageCircle } from 'lucide-react';
import { appConfig } from '../../config/appConfig';

interface WhatsAppGroupButtonProps {
  className?: string;
  size?: 'default' | 'sm';
  fullWidth?: boolean;
}

const WhatsAppGroupButton: React.FC<WhatsAppGroupButtonProps> = ({
  className = '',
  size = 'default',
  fullWidth = false,
}) => {
  const link = appConfig.company.whatsappGroupLink;

  if (!link) return null;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn btn-whatsapp group ${size === 'sm' ? 'btn-sm' : ''} ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      <MessageCircle size={size === 'sm' ? 18 : 20} />
      Join WhatsApp Group
    </a>
  );
};

export default WhatsAppGroupButton;
